"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PropTypeCustomAction = require("../../prop-type-custom-action/PropTypeCustomAction");
var _TopBarAction = _interopRequireDefault(require("../../../icons/top-bar-action/TopBarAction"));
var _SeparatorView = _interopRequireDefault(require("../separator/SeparatorView"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../../util/ServiceRegistry"));
require("!style-loader!css-loader!./CustomActions.css");
var _ConfigStoreConstants = require("../../../../../constants/ConfigStoreConstants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function insertTopBarSeparators(topbarActions, separatorIndex = 2) {
  if (topbarActions && topbarActions.length > separatorIndex) {
    topbarActions.splice(separatorIndex, 0, /*#__PURE__*/_react.default.createElement(_SeparatorView.default, null));
  }
  return topbarActions;
}
class CustomActions extends _react.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      actionsState: {}
    };
    this.renderPureReactActions = () => {
      const {
        actions
      } = this.props;
      const {
        actionsState
      } = this.state;
      return actions.map(({
        id,
        action: Action,
        showOnlyInTopBar,
        alwaysShow
      }) => {
        const {
          isVisible
        } = actionsState[id] || {};
        const actionClassNames = (0, _classnames.default)(["sdk-CustomActions-actionItem", {
          "sdk-CustomActions-alwaysShow": showOnlyInTopBar || alwaysShow
        }, {
          "sdk-CustomActions-actionItemHidden": isVisible === false
        }]);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: id,
          className: actionClassNames
        }, /*#__PURE__*/_react.default.createElement(Action, {
          action: {
            hide: this.modifyActionsState.bind(this, id, "isVisible", false),
            show: this.modifyActionsState.bind(this, id, "isVisible", true)
          }
        }));
      });
    };
    this.renderOurActions = () => {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      const {
        actions,
        makeToolsInactive
      } = this.props;
      const topbarActions = actions.map(action => {
        const {
          id,
          alwaysShow
        } = action;
        let inActiveLabel = "";
        let inActiveClass = "";
        if (makeToolsInactive && _ConfigStoreConstants.ANNOTATION_TOOL_TYPE_IDS.includes(id)) {
          inActiveLabel = appStore.intl.formatMessage({
            id: "tools.inactive.label"
          });
          inActiveClass = "sdk-CustomActions-actionItem-inactive";
        }
        const actionClassNames = (0, _classnames.default)(["sdk-CustomActions-actionItem", {
          "sdk-CustomActions-alwaysShow": alwaysShow
        }, inActiveClass]);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: id,
          className: actionClassNames
        }, /*#__PURE__*/_react.default.createElement(_TopBarAction.default, {
          action: action,
          inActiveLabel: inActiveLabel
        }));
      });
      return insertTopBarSeparators(topbarActions);
    };
  }
  // eslint-disable-line

  modifyActionsState(id, key, value) {
    const {
      actionsState
    } = this.state;
    const newState = {
      [key]: value
    };
    this.setState({
      actionsState: _objectSpread(_objectSpread({}, actionsState), {}, {
        [id]: newState
      })
    });
  }
  render() {
    const {
      actions
    } = this.props;
    let renderedActions = null;
    if (actions && actions.length > 0 && actions[0].label) {
      renderedActions = this.renderOurActions();
    } else {
      renderedActions = this.renderPureReactActions();
    }
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const customActionsClassName = `sdk-CustomActions-actions 
        ${appStore.enableModernViewer ? "sdk-CustomActions-actionsModernViewer" : ""}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: customActionsClassName
    }, renderedActions);
  }
}
CustomActions.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])).isRequired,
  makeToolsInactive: _propTypes.default.bool
};
CustomActions.defaultProps = {
  makeToolsInactive: false
};
var _default = exports.default = CustomActions;